import { defineMessages } from 'react-intl';

import { ClientStatus } from '../constants';

const messages = defineMessages({
  [ClientStatus.ACTIVE]: {
    description: 'Client active status',
    defaultMessage: 'Active',
    id: 'YHp4NR',
  },
  [ClientStatus.PENDING]: {
    description: 'Client pending status',
    defaultMessage: 'Pending',
    id: '/Ip/F+',
  },
  [ClientStatus.INACTIVE]: {
    description: 'Client inactive status',
    defaultMessage: 'Inactive',
    id: 'Y59NrI',
  },
  pageDescription: {
    defaultMessage: 'Clients delegate the orders they want you to fulfill. Configure how your relationship works.',
    id: 'UflQ/0',
    description: 'Settings > Clients > About Clients',
  },
  pageTitle: {
    defaultMessage: 'Clients',
    id: 'fMgQS9',
    description: 'Settings > Clients',
  },
  showInactiveClients: {
    defaultMessage: 'Show Inactive Clients',
    id: 'yv1aHl',
    description: 'settings.clientsetup.inactiveClients',
  },
  addNewClient: {
    defaultMessage: 'Add a new Client',
    id: '17D1Qw',
    description: 'settings > Clients > add new client button',
  },
  errorNotification: {
    defaultMessage: 'Error Loading Clients. Please Try again',
    id: '0O+BqJ',
    description: 'Settings > Clients > Error Notification',
  },
  modalHeader: {
    defaultMessage: 'Invite Client',
    id: '7Pf+lI',
    description: 'Settings > Clients > Invite Client Modal Header',
  },
  clientNameLabel: {
    defaultMessage: 'Client Name',
    id: 'Y9+fD5',
    description: 'Settings > Clients > Invite Client Modal Body clientNameLabel',
  },
  clientNameSubtext: {
    defaultMessage: 'This is an internal nickname only used within your ShipStation account.',
    id: 's1Q5xk',
    description: 'Settings > Clients > Invite Client Modal Body clientNameSubtext',
  },
  clientFacingCompanyNameLabel: {
    defaultMessage: 'Client-facing Company Name',
    id: 'JigMW7',
    description: 'Settings > Clients Label for "Company Name" value that will be visible to external clients',
  },
  clientFacingCompanyNameSubtext: {
    defaultMessage: 'The name clients will see associated with your company in ShipStation.',
    id: 'RqUq0B',
    description: 'Settings > Clients Label for "Company Name" value that will be visible to external clients',
  },
  emailLabel: {
    defaultMessage: 'Email',
    id: 'knck1c',
    description: 'Settings > Clients > Invite Client Modal Body emailLabel',
  },
  emailSubtext: {
    defaultMessage:
      "We will send a link to the client to approve the connection and configure their settings. Ensure the email address is associated with a client's ShipStation administrator account.",
    id: 'ZZOJU7',
    description: 'Settings > Clients > Invite Client Modal Body emailSubtext',
  },
  cancel: {
    defaultMessage: 'Cancel',
    id: 'qK3+Xp',
    description: 'Settings > Clients > Invite Client Modal Footer Cancel',
  },
  addClient: {
    defaultMessage: 'Add Client',
    id: 'obe+Jw',
    description: 'Settings > Clients > Invite Client Modal Footer Add Client',
  },
  apiSuccessMessage: {
    defaultMessage: 'Successfully sent invite',
    id: 'lWwTxA',
    description: 'Settings > Clients > API Invite Success',
  },
  apiErrorMessage: {
    defaultMessage: 'Error sending invite. Please try again.',
    id: 'VJECjv',
    description: 'Settings > Clients > API Invite Failure',
  },
  apiDuplicateInviteErrorMessage: {
    defaultMessage:
      'A client invitation has already been sent to that email address. Please contact support if you must resend an invitation to that email address.',
    id: 'iNhWNd',
    description: 'Settings > Clients > API inform the user that they have a pending client invitation with the attempted email address',
  },
  clientNameValidationErrorMessage: {
    defaultMessage: 'A Client with that name already exists.',
    id: 'ny5QnY',
    description: 'Settings > Clients > Duplicate Client Name Validation Error',
  },
  clientEmailValidationErrorMessage: {
    defaultMessage: 'A Client connection or invitation with that email address already exists.',
    id: 'ilZizS',
    description: 'Settings > Clients > Duplicate Client Email Validation Error',
  },
  cancelPendingClientButton: {
    defaultMessage: 'Cancel pending invite',
    id: 'NODPnz',
    description: 'Settings > Clients > Action button to cancel a pending client invitation',
  },
  cancelPendingClientModalHeader: {
    defaultMessage: 'Cancel pending invite',
    id: '8+VK3k',
    description: 'Settings > Clients > Cancel Pending Client Modal header for canceling a pending client invitation',
  },
  cancelPendingClientModalBody: {
    defaultMessage:
      'You are canceling a pending invite for client {clientName}. The client will no longer be able to connect to you from their ShipStation account.{br}{br}You may re-invite the client at any time.',
    id: 'Xm7nq7',
    description: 'Settings > Clients > Cancel Pending Client Modal body text to explain consequences of canceling the invitation',
  },
  cancelPendingClientError: {
    defaultMessage: 'Failed to cancel the pending client invitation.',
    id: '09i+qp',
    description: 'Settings > Clients > Cancel Pending Client Modal error notification',
  },
});

export default messages;
